import { render, staticRenderFns } from "./CurrentTransactions.vue?vue&type=template&id=14fe71ae&"
import script from "./CurrentTransactions.vue?vue&type=script&lang=js&"
export * from "./CurrentTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports